import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fonticons-fi': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M114.4 224H206.8L191.6 275.2H115.2V433C115.2 441 112.4 442.2 119.6 443L179.2 448.6V483H0V447.8L29.2 445C36.4 444.2 38.4 441.8 38.4 434.2V278.4C38.4 275.2 34.4 275.2 30.4 275.2H0V224H38.4V195.2C38.4 127.2 74.8 99.2 144.4 99.2 191.2 99.2 233.2 110.4 233.2 171.6L163.6 180C164 154.4 157.6 148.4 141.2 148.4 116 148.4 115.2 162 115.2 186V218C115.2 221.2 110.4 224 114.4 224zM384 483H243.2V448.6L271.2 445C278.4 444.2 281.6 442.6 281.6 435V287C281.6 281.4 277.6 277.8 272.4 276.2L239.2 267.4 248.4 227H358.4V435C358.4 443 354.8 443.8 362.4 445L384 448.6V483zM354 135.8L366.4 181.4 356.4 191.4 313.6 168.6 270.8 191.4 260.8 181.4 273.2 135.8 243.2 99.4 248 89.4H286L307.2 51H320L341.2 89.4H379.2L384 102.6 354 135.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fonticons-fi.js
// module id = XCDS
// module chunks = 144